Vue.component('ack-validation-resins-title', {
    delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
    template: '#ack-validation-resins-title',
    mounted() {
 
    },
    props:{
       validationInfo: { // :product-info
          type: Object,
          required: true
       },
       isMobile: {
         type: Boolean,
         required: true
       }
    },
    computed: {

    },
    data() {
      return {
 
      }
    },
    methods: {
      //...Vuex.mapActions(['sayHi', 'someAction']),
      //...Vuex.mapActions('shop', ['addSelectedItem', 'removeSelectedItem']),
 
 
 
    },
    beforeDestroy() {
 
    },
    watch: {
     isMobile: {
       handler() {
 
 
       },
       deep: false
     }
   }
  })